// useLayout combines header.js and footer.js vuex stores
export const useLayout = defineStore('layout', () => {
  const isLoading = ref(true)
  const showHeader = ref(true)
  const showMobileMenu = ref(false)
  const showDesktopMenus = ref(true)
  const showTermsAndConditions = ref(false)
  const showFooter = ref(true)
  const showFooterBoxes = ref(true)

  return {
    isLoading,
    showHeader,
    showMobileMenu,
    showDesktopMenus,
    showTermsAndConditions,
    showFooter,
    showFooterBoxes,
  }
})
